import { render, staticRenderFns } from "./survey-editor.vue?vue&type=template&id=18bf9780&scoped=true&"
import script from "./survey-editor.vue?vue&type=script&lang=js&"
export * from "./survey-editor.vue?vue&type=script&lang=js&"
import style0 from "./survey-editor.vue?vue&type=style&index=0&id=18bf9780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf9780",
  null
  
)

export default component.exports